import { Button, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import HeiUserAutocomplete from "../../../Common/components/HeiUserSearch/HeiUserAutocomplete";
import { UserSearch } from "../../../Common/models/UserSearch";

interface AddPackageMemberSectionProps {
    onAddMember: (name: string, email: string, adPrinciple: string, role: "Owner" | "Editor") => void;
    existingMembers: Array<{ email: string; adPrinciple: string }>;
}

const AddPackageMemberSection = ({
    onAddMember,
    existingMembers,
}: AddPackageMemberSectionProps): JSX.Element => {
    const autoComplete = React.useRef<HTMLInputElement>(null);
    const [selectedUser, setSelectedUser] = useState<UserSearch | null>(null);
    const [selectedRole, setSelectedRole] = useState<"Owner" | "Editor">("Editor");

    const handleUserChange = (user: UserSearch) => {
        setSelectedUser(user);
    };

    const handleAdd = () => {
        if (selectedUser) {
            onAddMember(
                selectedUser.name,
                selectedUser.email || selectedUser.adPrinciple,
                selectedUser.adPrinciple,
                selectedRole
            );
            resetForm();
        }
    };

    const resetForm = () => {
        setSelectedUser(null);
        setSelectedRole("Editor");
        if (autoComplete.current) {
            const clearButton = autoComplete.current.getElementsByClassName(
                "MuiAutocomplete-clearIndicator"
            )[0] as HTMLElement;
            if (clearButton) {
                clearButton.click();
            }
        }
    };

    // Mock getUsers to return existing members for validation
    const mockGetUsers = (field: string) => {
        if (field === "users") {
            return existingMembers;
        }
        return [];
    };

    // Mock addUser - we don't use this directly
    const mockAddUser = () => {
        // Intentionally empty - required by HeiUserAutocomplete interface
    };

    const handleCreateNewAccount = () => {
        // Intentionally empty - we don't support creating new accounts in package management
    };

    return (
        <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
            <HeiUserAutocomplete
                autoComplete={autoComplete}
                addUser={mockAddUser as any}
                getUsers={mockGetUsers as any}
                handleChange={handleUserChange}
                handleCreateNewAccount={handleCreateNewAccount}
                width="45%"
            />
            
            {selectedUser && (
                <>
                    <FormControl size="small" sx={{ width: "180px" }}>
                        <InputLabel shrink>Role*</InputLabel>
                        <Select
                            value={selectedRole}
                            onChange={(e) => setSelectedRole(e.target.value as "Owner" | "Editor")}
                            label="Role"
                            notched
                        >
                            <MenuItem value="Owner">Owner</MenuItem>
                            <MenuItem value="Editor">Editor</MenuItem>
                        </Select>
                    </FormControl>
                    
                    <Button
                        variant="contained"
                        onClick={handleAdd}
                        sx={{ height: 40 }}
                        size="small"
                    >
                        ADD
                    </Button>
                    
                    <Button
                        onClick={resetForm}
                        sx={{ height: 40 }}
                        size="small"
                    >
                        CANCEL
                    </Button>
                </>
            )}
        </div>
    );
};

export default AddPackageMemberSection;
